import styled from "styled-components";

const Container = styled.div`
  h3 {
    line-height: 30px;
    color: #cc5248;
    background-color: #ededed;
    font-weight: bold;
  }

  label {
    margin-bottom: 5px;
    font-weight: bold;
  }

  .MuiOutlinedInput-root.filter {
    width: 100%;
    height: 90px;
  }

  .MuiDataGrid-pinnedColumnHeaders
  {
     padding-right : 0px !important;
  }

  .MuiOutlinedInput-root.filter .MuiOutlinedInput-input {
    position: absolute;
    top: 0;
  }

  .MuiFormControl-root.MuiTextField-root {
    width: 100%;
  }

  .buttons-container {
    float: right;
  }

  .buttons-container .MuiButton-root {
    color: white;
    background-color: grey;
    width: 80px;
    margin-left: 20px;
  }
`;

const Button = styled.div`
  float: right;
  color: white;
  background-color: grey;
`;

const ButtonContainer = styled.div`
  bottom: 0;
  right: 0;
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1em;
  padding-bottom: 1em;
  padding-right: 1em;
  z-index: 1;

  .MuiButton-root {
    color: white;
    // background-color: grey;
    width: 80px;
  }
`;

export { Container, Button, ButtonContainer };
